// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-complete[data-v-1c8f2923]{text-align:center}.create-complete .complete-title[data-v-1c8f2923]{font-size:18px;font-weight:500;color:#0bc15c;margin-bottom:30px}.create-complete .complete-subtitle[data-v-1c8f2923]{color:#273142;margin-bottom:50px}.create-complete .complete-subtitle span[data-v-1c8f2923]{color:#f27a1a;border-bottom:1px solid #f27a1a}", ""]);
// Exports
module.exports = exports;
